import { useId } from 'react';
import { OverlayTrigger } from 'react-bootstrap';

import Tooltip from '../Tooltip';

export interface OverlayTriggerTooltipProps {
  children: React.ReactNode;
  content?: React.ReactNode;
  isFullWidth?: boolean;
  placement?: 'bottom' | 'left' | 'right' | 'top';
}

const OverlayTriggerTooltip = ({
  children,
  content,
  isFullWidth,
  placement = 'bottom',
}: OverlayTriggerTooltipProps) => {
  const tooltipId = useId();

  if (!content) return children;

  return (
    <OverlayTrigger
      overlay={
        <Tooltip data-testid="active-tooltip" id={tooltipId} isFullWidth={isFullWidth}>
          {content}
        </Tooltip>
      }
      placement={placement}
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};

export default OverlayTriggerTooltip;
